// USA
export const locale = {
  admin_login: "Admin Login",
  login: "Login",
  email: "Email",
  password: "Password",
  you_are_not_admin: "You are not an Admin!",
  dashboard: "Dashboard",
  user: "User",
  organizer: "Organizer",
  single_user: "User",
  influencer: "Influencer",
  unapproved: "Organizers to be confirmed",
  unapproved_organizer: "Unapproved Organizer",
  event: "Event",
  post: "Post",
  transaction: "Transaction",
  refund: "Refund",
  refund_fee: "Refund Fee",
  withdraw: "Withdraw",
  report: "Report",
  reported_user: "Reported User",
  reported_post: "Reported Post",
  reported_event: "Reported Event",
  system: "System",
  change_password: "Change Password",
  send_message_to_users: "Send message to users",
  logout: "Logout",
  confirm_logout: "Are you sure you want to logout now?",
  deleted: "Deleted",
  sale: "Sale",
  gross_sale: "Gross Sale",
  net_sale: "Net Sale",
  refunded: "Refunded",
  please_wait: "Please wait ...",
  online: "Online",
  approve: "Approve",
  decline: "Decline",
  no_data_found: "No data found!",
  confirm_approve_organizer:
    "Are you sure you want to approve this user as Organizer?",
  confirm_approve_single_user:
    "Are you sure you want to approve this user as User?",
  success: "Success",
  ticket_price: "Ticket Price",
  tax_price: "Tax Price",
  service_charge: "Service Charge",
  total_price: "Total Price",
  tickets: "Tickets",
  paid: "Paid",
  requested: "Requested",
  total_balance: "Total Balance",
  not_paid: "Not paid",
  already_paid: "Already paid",
  pending: "Pending",
  refund_now: "Refund now",
  remain_balance: "Remain Balance",
  withdraw_amount: "Withdraw Amount",
  status: "Status",
  payment_done: "Payment Done",
  confirm_withdraw_done:
    "Are you sure you have already done this withdraw request?",
  confirm_delete_report: "Are you sure you want to delete this report?",
  current_password: "Current Password",
  new_password: "New Password",
  confirm_password: "Confirm Password",
  modify: "Modify",
  password_does_not_match: "Password does not match!",
  admin_password_changed_login_again:
    "The admin password is changed successfully, please login again.",
  current_password_incorrect: "The current password is incorrect.",
  title: "Title",
  message: "Message",
  send: "Send",
  confirm_send_message:
    "Are you sure you want to send this message to all users?",
  confirm_delete_message: "Are you sure you want to delete this message?",
  report_type_1: "Spam",
  report_type_2: "Violence",
  report_type_3: "Nudity",
  report_type_4: "Hate Speech",
  report_type_5: "Terrorism",
  report_type_6: "Unauthorized Sales",
  select_month: "Select month",
  select_date_range: "Select date range",
  // 2023-02-23 16:35
  blocked: "Blocked",
  block: "Block",
  unblock: "Unblock",
  reason: "Reason",
  confirm_block_user:
    "Once block this user, this user can do nothing! Are you sure you want to block this user?",
  confirm_unblock_user: "Are you sure you want to unblock this user?",
  confirm_delete_: "Are you sure you want to delete this {0}?",
  // 2023-03-30 14:36
  story: "Story",
  // 2023-11-28
  add_coupon: "Add coupon",
  coupon_code: "Coupon code",
  percent: "Percent",
  total_quantity: "Total quantity",
  used_quantity: "Used quantity",
  confirm: "Confirm",
  edit: "Edit",
  delete: "Delete",
  // 2024-04-29
  clear: "Clear",
  cancel: "Cancel",
  select_influencer: "Select Influencer",
  discount: "Discount",
  total_discount: "Total Discount",
  sales_total: "Sales Total",
  sales_volume_organizer: "Sales Volume Organizer",
  billing_document: "Billing Document",
  // 2025-08-30
  highlight: "Highlight",
  set_highlight: "Set Highlight",
  remove_highlight: "Remove Highlight",
  alarm_list: "Alarm List",
  created_at: "Created At",
  export: "Export",
  export_buyers: "Export Buyers",
  change_service_fee: "Change service fee",
  save: "Save",
  service_fee: "Service Fee",
  service_fee_percent: "Service Fee Percent",
  no_user_selected: "No user selected",
  invalid_service_fee: "Invalid service fee",
  invalid_service_tax: "Invalid service tax",
  date_range: "Date Range",
  details: "Details",
  all: "All",
  pdf_generated_successfully: "PDF generated successfully",
};
